import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/cross.svg'


const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "body" }
const _hoisted_7 = { class: "fw-bold mb-2" }
const _hoisted_8 = { class: "h-100 d-flex flex-column" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-4" }
const _hoisted_11 = { class: "mt-3" }
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = { class: "col-4" }
const _hoisted_15 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_stripe_form = _resolveComponent("stripe-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_localized_text, {
          localizedKey: "Buy Package",
          text: "Buy Package"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_localized_text, {
            localizedKey: "Garment included",
            text: "Garment included"
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.localModel.garmentsCalculation as OM.TextIdentifier[]), (garm, k) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "me-1 ms-1 mb-1",
                key: k
              }, _toDisplayString(garm.text), 1))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_localized_text, {
            class: "fw-bold",
            localizedKey: "Total Price",
            text: "Total Price"
          }),
          _createElementVNode("h4", _hoisted_11, _toDisplayString(_ctx.$filters.currency(_ctx.localModel.price)) + " CHF", 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_localized_text, {
            class: "fw-bold",
            localizedKey: "Months",
            text: "Months"
          }),
          _createElementVNode("h4", _hoisted_13, _toDisplayString(_ctx.localModel.monthDuration), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_localized_text, {
            class: "fw-bold text-nowrap",
            localizedKey: "Concurrent Accesses",
            text: "Concurrent Accesses"
          }),
          _createElementVNode("h4", _hoisted_15, _toDisplayString(_ctx.localModel.userLicense), 1)
        ])
      ]),
      _createVNode(_component_stripe_form, {
        class: "mt-3",
        "user-identifier": _ctx.$store.state.loggedUser.identifier,
        "user-name": _ctx.$store.state.loggedUser.username,
        termsAndCondition: _ctx.termsAndCondition,
        intentCb: _ctx.intentCb,
        onComplete: _ctx.onPayComplete
      }, null, 8, ["user-identifier", "user-name", "termsAndCondition", "intentCb", "onComplete"])
    ])
  ]))
}